import React from 'react';
import { IconProps } from '.';

const SvgInfoBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M13.5 4h-3v3h3V4ZM13.5 10h-3v10h3V10Z' />
    </svg>
  );
};

export default SvgInfoBold;
